import React, { useState, useEffect } from "react";
import { Container, Card, Row, Col, Button, Alert } from "react-bootstrap";
import { Link, useLocation } from "react-router-dom";
import axiosInstance from "../../api/axiosInstance";
import colors from "../../constants/colors";
import { formatPrice } from "../../utils/formatPrice";
import { FaCheck } from "react-icons/fa";

const OrderSuccessPage = () => {
  const [orderDetails, setOrderDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const location = useLocation();
  const { orderDetails: initialOrderDetails, orderId: orderIdFromState } = location.state || {};

  useEffect(() => {
    if (initialOrderDetails) {
      setOrderDetails(initialOrderDetails);
      setLoading(false);
    } else if (orderIdFromState) {
      const fetchOrderDetails = async () => {
        try {
          const response = await axiosInstance.get(`/order/${orderIdFromState}`);
          setOrderDetails(response);
        } catch (err) {
          console.error("Erro ao carregar detalhes da encomenda:", err);
          setError("Não foi possível carregar os detalhes da encomenda.");
        } finally {
          setLoading(false);
        }
      };
      fetchOrderDetails();
    } else {
      setError("Informação da encomenda não encontrada.");
      setLoading(false);
    }
  }, [initialOrderDetails, orderIdFromState]);

  if (loading) {
    return (
      <Container className="py-5 text-center">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">A carregar...</span>
        </div>
      </Container>
    );
  }

  if (error) {
    return (
      <Container className="py-5">
        <Alert variant="danger">{error}</Alert>
        <Button as={Link} to="/" style={{ backgroundColor: colors.secondary, color: colors.light, borderColor: colors.secondary }}>
          Voltar para a Página Inicial
        </Button>
      </Container>
    );
  }

  return (
    <Container className="py-5">
      <Row className="justify-content-center">
        <Col md={8}>
          <Card className="shadow-sm text-center">
            <Card.Body className="p-5">
              <div className="mb-4">
                <div
                  style={{
                    width: "80px",
                    height: "80px",
                    borderRadius: "50%",
                    backgroundColor: colors.success,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "0 auto",
                  }}
                >
                  <FaCheck
                    style={{ fontSize: "3rem", color: "#fff" }}
                  />
                </div>
              </div>

              <h1 className="mb-3">Obrigada pela tua encomenda!</h1>
              <p className="text-muted mb-4">
                A tua encomenda foi processada com sucesso. Enviaremos uma
                confirmação por e-mail em breve.
              </p>

              {orderDetails && (
                <div className="text-start mb-4">
                  <div className="d-flex justify-content-between mb-2">
                    <strong>Número da Encomenda:</strong>
                    <span>#{orderDetails.id}</span>
                  </div>
                  <div className="d-flex justify-content-between mb-2">
                    <strong>Data:</strong>
                    <span>
                      {new Date(orderDetails.order_date).toLocaleDateString(
                        "pt-PT"
                      )}
                    </span>
                  </div>
                  <div className="d-flex justify-content-between mb-2">
                    <strong>Total:</strong>
                    <span>
                      {formatPrice(orderDetails.total_price_with_tax)}€
                    </span>
                  </div>
                  <div className="d-flex justify-content-between mb-2">
                    <strong>Método de Pagamento:</strong>
                    <span>
                      {orderDetails.payment_method === "multibanco"
                        ? "Multibanco"
                        : "MB WAY"}
                    </span>
                  </div>
                </div>
              )}
              <div className="d-grid gap-3 mt-4">
                <Button as={Link} to="/minhas-encomendas" style={{ backgroundColor: colors.secondary, color: colors.light, borderColor: colors.secondary }}>
                  Ver as minhas encomendas
                </Button>
                <Button as={Link} to="/produtos" style={{ backgroundColor: colors.secondary, color: colors.light, borderColor: colors.secondary }}>
                  Continuar a comprar
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default OrderSuccessPage;
